/* eslint-disable */

// from https://stackoverflow.com/questions/11381673/detecting-a-mobile-browser
const isMobile = navigator.userAgent.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/i)
export default isMobile
